<fab-loading-spinner color="primary" *ngIf="showSpinner"
                     id="loading-spinner"></fab-loading-spinner>
<div id="header-container">
  <div>
    <h1 id="header-text">Business Portfolio Transfer</h1>
  </div>
  <div>
    <button mat-flat-button color="primary" id="transfer-button" class="action-button"
            [disabled]="selectedProgramCodes.length === 0"
            (click)="onTransferClick()">
      Transfer
    </button>
  </div>
</div>
<div class="h-100">
  <div class="gfs-table">
    <ag-grid-angular
      style="height: 100%; width:100%;"
      class="ag-theme-quartz"
      [rowData]="prgmCodeList"
      [columnDefs]="colDefinition"
      [autoSizeStrategy]="autoSizeStrategy"
      [rowSelection]="rowSelection"
      (rowSelected)="onSelect($event)"
    />
  </div>
</div>
